import React from 'react';
import {createRoot} from 'react-dom/client';
import LoadingOverlay from '../loading-overlay/loading-overlay.react';
import Tracking from '../../clientlibs/clientlib-publish/src/js/tracking';

/**
 * JavaScript logic for Toggle Filter component
 */
class TogglefilterNew {
    constructor(element, baseUseClass) {
        this.baseUseClass = baseUseClass;
        this.attachLoadingOverlay = this.attachLoadingOverlay.bind(this);
        this.selector = '.magat.cmp-toggle-filter-new';
        this.loadingSelector = '.cmp-toggle-filter-new__loading-overlay';
        this.config = {};
        this.xor = false;
        this.vfc = false;
        this.loadingReactRoot = undefined;
        this.scrollAnimationTimeout = undefined;

        this.loadingDebouncer = null;
        this.isLoadingRequestCompleted = true;

        this.LOADING_OVERLAY_DURATION_SECONDS = 2;

        this.log('Before initializing...');
        this.init(element);
        this.log('After initializing.');

        this.log('Before attaching loading overlay');
        this.attachLoadingOverlay(element);
        this.log('After attaching loading overlay');
    }

    log = (title, ...args) => {
        if (this.baseUseClass.isDebugLoggingOn()) {
            if (!args.length) {
                console.log(`togglefilternew.lazy.js | ${title}`);
            } else {
                console.log(`togglefilternew.lazy.js | ${title}`, args);
            }
        }
    };

    // initialization --> only one toggle filter component at the page is supported!
    init = (element) => {
        this.xor = element.getAttribute('data-xor') === 'true';
        this.vfc = element.getAttribute('data-vfc') === 'true';
        $(document).customOn('refresh', (event, elem) => {
            if (!elem) {
                elem = document.body;
            }
            const toggleFilter = $(elem).find(this.selector);
            const that = this;
            if (toggleFilter.length > 0) {
                $(toggleFilter).each((idx, tf) => {
                    if ($(tf).is(':visible')) {
                        that.process($(tf));
                    }
                });
            }
        });
        this.process($(element));
    };

    process(elem) {
        this.log('Processing...');

        // find all toggle buttons
        const toggleButtons = $(elem).find('>.cmp-toggle-filter-new__toggle-container>.cmp-toggle-filter-new__toggle-area button');
        this.config = $(elem).closest(this.selector).find('>div').data('config');
        const theConfig = this.config;
        if (toggleButtons.length > 0 && theConfig && Object.keys(theConfig).length) {
            this.log('Inside the IF');

            // initialize the toggle button click
            $(toggleButtons).off('click');
            toggleButtons.click((e) => {
                this.log('Toggle Button has been clicked!');

                this.log('Disabling button until processing done');
                $(e.currentTarget).prop('disabled', true);

                // The scroll logic is not required right now [ROBO-1213]
                // this.tryScrollToTariffTable(elem);

                // toggle the button
                $(e.currentTarget).toggleClass('active');

                // set aria attributes
                if ($(e.currentTarget).hasClass('active')) {
                    $(e.currentTarget).attr('aria-checked', true);
                } else {
                    $(e.currentTarget).attr('aria-checked', false);
                }

                const radioArea = $(e.currentTarget).closest('.cmp-toggle-filter-new__toggle-container').find('.cmp-toggle-filter-new__radio');
                if (radioArea.length > 0) {
                    radioArea.toggleClass('active');
                }
                if (this.xor) {
                    toggleButtons.each(function (idx, toggleButton) {
                        if ($(toggleButton).hasClass('active') && ($(toggleButton).attr('id') !== $(e.currentTarget).attr('id'))) {
                            $(this).removeClass('active');
                            $(this).closest('.cmp-toggle-filter-new__toggle-container').find('.cmp-toggle-filter-new__radio').removeClass('active');
                        }
                    });
                }

                // set the matching xf variation
                this.setMatchingVariation(elem, theConfig);
                window.history.pushState('', document.title, window.location.pathname + window.location.search);
                Tracking.trackToggleClick($(e.currentTarget).hasClass('active'), this.vfc, $(e.currentTarget).data('tag'), this.xor);

                this.log('Enabling button when the processing is over...');
                $(e.currentTarget).prop('disabled', false);
                $(e.currentTarget).focus();
            });

            const radios = $(elem).find(':radio');
            if (radios.length > 0) {
                $(radios).off('click');
                $(radios).on('click', (e) => {
                    $(e.currentTarget).closest('.cmp-toggle-filter-new__radio').find('.cmp-form-options__field--radio').removeClass('active');
                    $(e.currentTarget).addClass('active');
                    // The scroll logic is not required right now [ROBO-1213]
                    // this.tryScrollToTariffTable(elem);

                    this.setMatchingVariation(elem, theConfig);
                    const tag = $(e.currentTarget).closest('.cmp-toggle-filter-new__toggle-container').find('button').data('tag');
                    const label = $(e.currentTarget).closest('.cmp-form-options__field-label').find('.cmp-form-options__field-description').text()
                        .trim();
                    Tracking.trackToggleRadioClick(tag, label);
                });
            }

            // toggle the buttons to 'on' if the user logs in
            $(window).customOn('loggedInEvent', () => {
                this.toggleButtonsForLoggedInUser(toggleButtons);
            });

            // set the initial state of the toggle buttons
            this.setInitialStateOfToggles(elem, toggleButtons);

            // set the initial matching xf variation
            this.setMatchingVariation(elem, theConfig);

            // set the xf variation visible
            $(elem).closest(this.selector).find('.experiencefragment.xfpage').css('visibility', 'visible');
        }
    }

    /**
     * sets the initial state of the toggle buttons
     * @param elem the toggle button element
     * @param toggleButtons a list of toggle buttons
     */
    setInitialStateOfToggles(elem, toggleButtons) {
        // enable deep linking via query parameter
        const queryString = window.location.search;
        // check if the parameter 'toggleFilter' is present
        const urlParams = new URLSearchParams(queryString);
        let toggleFilter = urlParams.get('toggleFilter') || window.location.hash;
        toggleFilter = toggleFilter?.replace('#', '');
        if (toggleFilter != null && toggleFilter.length > 0) {
            // try to get the button with the ID from URL parameter
            const toggleButtonIds = toggleFilter.split(/[\s/]+/);
            $(toggleButtonIds).each((index, toggleButtonId) => {
                if (!toggleButtonId) return;
                if (!toggleButtonId.startsWith('#')) {
                    toggleButtonId = `#${toggleButtonId}`;
                }
                // set the button to 'on' if it isn't already disabled
                const toggleButton = $(elem).closest(this.selector).find(toggleButtonId);
                if (toggleButton.length > 0 && $(toggleButton).attr('disabled') === undefined) {
                    this.toggleButton($(toggleButton), true, false);
                }
            });
        } else {
            // check the logged-in user state
            this.toggleButtonsForLoggedInUser($(toggleButtons));
        }
    }

    /**
     * Toggle buttons if they should be set to 'on' when the user is logged in
     * @param toggleButtons the toggle buttons
     */
    toggleButtonsForLoggedInUser(toggleButtons) {
        if (window.Login && window.Login.authenticated()) {
            $(toggleButtons).each((index, toggleButton) => {
                if ($(toggleButton).data('detectLoggedInUser') === true && $(toggleButton).attr('disabled') === undefined) {
                    this.toggleButton($(toggleButton), true, false);
                }
            });
        }
    }

    /**
     * sets the matching xf variation
     * @param elem the current toggle button component
     * @param theConfig the component config with XFs and their tags
     */
    setMatchingVariation(elem, theConfig) {
        this.log('Inside setMatchingVariation()');
        this.updateLoadingState(true, elem);

        // get current selected tags
        const selectedTags = this.getCurrentSelectedTags(elem);
        const selectedTagsStr = JSON.stringify(selectedTags);
        this.log('selected tag successfully retrieved.');

        // get fitting variation from config regarding the selected tags
        let fittingVariation = null;
        $.each(theConfig.variations, (variation, tags) => {
            const tagsStr = JSON.stringify(tags);
            if (tagsStr === selectedTagsStr) {
                fittingVariation = variation;
            }
        });
        this.log('After processing config\'s variations, the following fittingVariation has been found:', fittingVariation);

        // if no fitting variation is found, use the default variation
        if (fittingVariation === null) {
            fittingVariation = theConfig.defaultVariation;
            this.log('Because no fittingVariation was found, default is being used:', fittingVariation);
        }

        // if the current variation is not the determined variation, load the determined variation and replace the content
        const self = this;
        if (theConfig.currentVariation !== fittingVariation) {
            this.log('Has been detected that current Variation is not equal to the fittingVariation');

            let requestURL = `${fittingVariation}.content.html`;
            if (!$('html').hasClass('publish-instance')) {
                requestURL += '?wcmmode=disabled';
            }

            this.updateLoadingState(true, elem);
            this.log('AJAX Request has been begun the work...');

            $.ajax({
                url: requestURL,
                async: true,
            })
                .done((data) => {
                    const xfpage = $(elem).closest(self.selector).find('.experiencefragment.xfpage');
                    // set the retrieved data to the content
                    xfpage.html(data);

                    // save the fitting variation as current variation
                    theConfig.currentVariation = fittingVariation;

                    // trigger refresh event
                    $(document).trigger('refresh', [xfpage]);

                    // trigger lazy loading event
                    const lazyEvent = new Event('immediateJSLoadFinished', {'bubbles': true, 'cancelable': true});
                    document.dispatchEvent(lazyEvent);

                    // set the xf content visible
                    xfpage.css('visibility', 'visible');

                    this.log('AJAX Request has been completed.');
                    this.updateLoadingState(false, elem);
                });
        } else {
            this.updateLoadingState(false, elem);
        }
    }

    /**
     * Toggles related toggle button
     * @param toggleButton a related toggle button
     * @param on if true, the buttons is toggled to 'on' otherwise to 'off'
     * @param setDisabled if true, the button will be disabled after setting
     */
    toggleButton(toggleButton, on, setDisabled) {
        if (on && !$(toggleButton).hasClass('active')) {
            $(toggleButton).addClass('active');
            $(toggleButton).attr('aria-checked', true);
        } else if (!on) {
            $(toggleButton).removeClass('active');
            $(toggleButton).attr('aria-checked', false);
        }
        // related toggle buttons were disabled
        setDisabled && $(toggleButton).attr('disabled', true);
    }

    /**
     * Related to the toggle button states, the tag list is determined
     * @param component the toggle button component
     * @returns a list with the current selected tags
     */
    getCurrentSelectedTags(component) {
        const result = [];
        const toggleButtons = component.find('.magat-toogle-btn');
        $(toggleButtons).each((index, toggleButton) => {
            if ($(toggleButton).hasClass('active')) {
                result.push($(toggleButton).data('tag'));
                const radioArea = $(toggleButton).closest('.cmp-toggle-filter-new__toggle-container').find('.cmp-toggle-filter-new__radio');
                if (radioArea.length > 0) {
                    if (radioArea.find('.radio2').hasClass('active')) {
                        result.push($(radioArea).data('tag'));
                    }
                }
            }
        });
        // sort alphabetically for easier comparison
        result.sort();
        return result;
    }

    attachLoadingOverlay(rootElement) {
        if (!rootElement) {
            this.log('Could not attach LoadingOverlay because rootElement is undefined!');
            return false;
        }
        if (this.loadingReactRoot) {
            this.log('LoadingOverlay root element already initiated.');
            return false;
        }

        this.log('Before creating the React Root');
        this.log('Root element:', rootElement);
        this.log('loading overlay container', rootElement.parentElement.querySelector('.cmp-toggle-filter-new__loading-overlay'));
        const root = createRoot(rootElement.parentElement.querySelector('.cmp-toggle-filter-new__loading-overlay'));
        this.log('Before rendering LoadingOverlay');
        root.render(<LoadingOverlay loadingHeadline={'Tarife werden geladen'} isLoading={false}/>);
        this.loadingReactRoot = root;
        return true;
    }

    updateLoadingState = (isLoading, elem) => {
        this.log('updateLoadingState', isLoading);

        if (this.loadingReactRoot === undefined && !this.attachLoadingOverlay()) {
            return;
        }

        const renderLoadingOverlay = (_isLoading) => {
            this.log('Re-rendering LoadingOverlay with status:', _isLoading);
            $(elem).parent().find(this.loadingSelector).addClass(_isLoading ? 'shown' : 'hidden');
            $(elem).parent().find(this.loadingSelector).removeClass(_isLoading ? 'hidden' : 'shown');
            this.loadingReactRoot?.render(<LoadingOverlay loadingHeadline={'Tarife werden geladen'} isLoading={_isLoading}/>);
        };

        if (isLoading) {
            renderLoadingOverlay(true);

            if (this.loadingReactRoot) {
                clearTimeout(this.loadingDebouncer);
            }
            this.loadingDebouncer = null;
            this.loadingDebouncer = setTimeout(() => {
                if (this.isLoadingRequestCompleted) {
                    renderLoadingOverlay(false);
                }
            }, this.LOADING_OVERLAY_DURATION_SECONDS * 1000);
        } else {
            this.isLoadingRequestCompleted = true;
        }
    };

    tryScrollToTariffTable = (elem) => {
        this.log('Scroll to the middle of TarifTable if any exist');
        const xfpage = $(elem)?.closest(this.selector)?.find('.experiencefragment.xfpage');
        if (!xfpage) {
            this.log('Experience fragment not found!');
            return;
        }

        const tariffTableContentElement = xfpage[0];
        if (!tariffTableContentElement) {
            this.log('tariffTableContentElement could not be found! The scroll-jump is impossible.');
            return;
        }
        this.log('Found tariffTableContentElement!');

        if (this.scrollAnimationTimeout) {
            this.log('Clearing scroll animation timeout');
            this.scrollAnimationTimeout = undefined;
        }

        let headerHeight;
        if (!this.baseUseClass) {
            headerHeight = 80;
            this.log(`Applied default header height: ${headerHeight}`);
        } else {
            headerHeight = this.baseUseClass.getHeaderHeight();
            this.log(`Found headerHeight: ${headerHeight}`);
            if (headerHeight === undefined || headerHeight === null) {
                headerHeight = 80;
                this.log(`Applied default header height: ${headerHeight}`);
            }
        }

        const scrollPositionY = Math.round(
            tariffTableContentElement.getBoundingClientRect().top
            + document.documentElement.scrollTop
            - headerHeight * 1.1,
        );
        this.log(`Final scroll position for Y axis: ${scrollPositionY}`);

        window.scrollTo({
            top: scrollPositionY,
            left: window.scrollX,
            behavior: 'smooth',
        });
    };
}

export default TogglefilterNew;
